import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MediaService } from '@studiobuki/web-core/lib/media';

@Component({
  selector: 'app-section-metro-banner',
  templateUrl: './section-metro-banner.component.html',
  styleUrls: ['./section-metro-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionMetroBannerComponent {
  @Input() book: string = 'tokyo-metro';

  constructor(public media: MediaService) {}
}
